export  class RootKeyProvider {
    static rootId: number = 1;
}

